import Vue from 'vue'
import vueScrollTo from 'vue-scroll-to'

Vue.use(vueScrollTo, { speed: 400, padding: 10 })
